import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import usePurchaseProcessEndedEvent from '@contentlab/hooks/analytics/use-purchase-process-ended-event';
import {FLOW_NAMES} from '@/lib/analytics/analyticsConstants';
import {
  getContentLabWebPaymentIds,
  removeContentLabWebPaymentIds,
} from '@/utils/LtidStorage';

type PurchaseStatus = 'success' | 'cancel' | 'existingSubscriber';

const PURCHASE_STATUS_TO_RESULT_MAP: Record<
  PurchaseStatus | 'unknownStatus',
  [string, string]
> = {
  success: ['success', ''],
  cancel: ['success', ''],
  existingSubscriber: ['failure', 'existing_subscriber'],
  unknownStatus: ['', ''],
};

function usePurchaseProcessCompletion() {
  const {purchaseProcessEnded} = usePurchaseProcessEndedEvent(
    FLOW_NAMES.CONTENT_STUDIO.PRICING
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const purchaseStatus = searchParams.get('purchaseStatus');

  const [result, error] =
    PURCHASE_STATUS_TO_RESULT_MAP[purchaseStatus as PurchaseStatus] ??
    PURCHASE_STATUS_TO_RESULT_MAP.unknownStatus;

  useEffect(() => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('purchaseStatus');
    setSearchParams(newSearchParams);
    if (purchaseStatus) {
      const webPaymentIds = getContentLabWebPaymentIds();
      purchaseProcessEnded({
        flow_id: webPaymentIds?.flowId || '',
        presentation_id: webPaymentIds?.presentationId || '',
        process_id: webPaymentIds?.processId || '',
        product_id: webPaymentIds?.productId || '',
        result,
        error,
        product_name: webPaymentIds?.productId || '',
      });

      removeContentLabWebPaymentIds();
    }
  }, []);
}

export default usePurchaseProcessCompletion;
